import axios from 'axios';
import qs from 'qs';
import baseUrl from '@/utils/lib/base-url'; //基础接口地址
import tokenVerify from '@/utils/lib/token-verify'; //token验证
import {
    Toast
} from 'vant';

/* 通用设置 */
axios.defaults.timeout = 1000 * 35; //请求超时设置，30秒超时
// axios.defaults.headers.post['Content-type'] = 'application/json;charset=UTF-8'; //设置数据格式
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; // 设置数据格式

/* 环境切换 */
axios.defaults.baseURL = baseUrl();

/**
 * 根据配置设置是否显示加载状态
 * @param {Object} config 请求配置对象
 */
function toastLoading(config) {
    let attrStr = 'showLoading'; //属性名
    let data = config.method === 'get' ? config.params : config.method === 'post' ? qs.parse(config.data) : {};
    if (data[attrStr] !== false && data[attrStr] !== "false") {
        Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击

            loadingType: 'spinner',
            message: '正在加载'
        });
    }

    removeRequestParameter(config, [attrStr]); //删除参数

}

/**
 * 添加全局请求参数
 * @param {Object} config  axios请求的配置对象
 * @param {Object} params 需要添加到请求参数中的对象
 * @returns {Object}  返回添加必填参数后的config配置
 */
function addRequestParameter(config, params) {
    if (config && params) {
        let data = null;

        if (config.method === 'get') {
            data = Object.assign(config.params || {}, params); //合并参数
            config.params = data;
        } else if (config.method === 'post') {
            data = qs.parse(config.data); //解析参数
            data = Object.assign(data, params); //合并参数
            data = qs.stringify(data); //序列化参数
            config.data = data;
        }
    }
    return config;
}

/**
 * 删除全局中指定请求参数
 * @param {Object} config  axios请求的配置对象
 * @param {Array} params 需要添加到请求参数中的属性名数组
 * @returns {Object}  返回添加必填参数后的config配置
 */
function removeRequestParameter(config, params) {
    if (config && params) {
        let data = {};
        switch (config.method) {
            case 'get':
                data = config.params;
                break;
            case 'post':
                data = qs.parse(config.data); //解析参数
                break;
        }
        /* 遍历清除属性 */
        for (let v of params) {
            for (let k in data) {
                if (v === k) {
                    delete data[k];
                }
            }
        }

        if (config.method === 'get') {
            config.params = data;
        } else if (config.method === 'post') {
            config.data = qs.stringify(data); //序列化参数
        }
    }
    return config;
}

/* 取消请求设置 */
const CancelToken = axios.CancelToken;
let pendList = [];

/**
 * 移除重复请求
 * @param {Object} config  请求配置对象
 */
function removePending(config) {
    for (let p of pendList) {
        let currentPend = createInterceptUrl(config); //本次请求信息
        let historyPend = config.url.includes(axios.defaults.baseURL) ? axios.defaults.baseURL + p.u : p.u; //历史请求信息(请求的config.url中不包含baseUrl，但响应中的url会包含baseUrl，此处先处理两者差异)
        let isMatch = currentPend === historyPend; //是否匹配

        if (isMatch) {
            p.f(); //执行取消操作
            pendList.splice(p, 1);
            return;
        }
    }
}

/**
 * 延迟请求，相同请求不得在短时间内重复发送
 * @param {Array} reqList - 请求缓存列表
 * @param {String} url - 当前请求地址
 */
function delayRepeatRequest(config) {
    setTimeout(() => {
        removePending(config);
    }, 500);
}

/**
 * 创建用于拦截请求的标识，为保证请求信息完整，组合了请求的地址、类型、参数
 * @param {Object} config  axios请求的配置对象
 * @returns {String}  返回用于拦截的字符串标识
 */
function createInterceptUrl(config) {
    return config.url + '&' + config.method + '&' + qs.stringify(config.params) + '&' + (typeof config.data === 'object' ? qs.stringify(config.data) : config.data);
}

/* 请求拦截 */
axios.interceptors.request.use(
    config => {
        config = addRequestParameter(config, {
            token: window.sessionStorage.token //添加全局token
        });
        // console.log(config.params, 5588)
        if (!tokenVerify()) {
            //如果token为空则取消请求
            config.cancelToken = new CancelToken(c => {
                c();
            });
        } else {
            removePending(config); //在一个axios发送前执行一下取消操作

            /* 创建取消请求的token，并把本次请求的信息添加到请求列表 */
            config.cancelToken = new CancelToken(c => {
                pendList.push({
                    u: createInterceptUrl(config),
                    f: c
                });
            });
        }

        toastLoading(config); //加载loading效果
        return config;
    },
    error => {
        return Promise.error(error);
    }
);

/* 响应拦截 */
axios.interceptors.response.use(
    response => {
        delayRepeatRequest(response.config); //在一个axios响应后再执行一下取消操作，把已经完成的请求从pendList中移除
        Toast.clear();
        return response.status === 200 ? Promise.resolve(response) : Promise.reject(response); //状态码为200接口访问成功，其他抛出错误
    },
    error => {
        Toast.clear();
        if (axios.isCancel(error)) {
            return Promise.reject(null); //如果是被取消请求,错误中返回null
        }

        if (error.response && error.response.status) {
            switch (error.response.status) {
                case 400:
                    error.message = '错误请求';
                    break;
                case 401:
                    error.message = '未授权，请重新登录';
                    break;
                case 403:
                    error.message = '拒绝访问';
                    break;
                case 404:
                    error.message = '请求错误，未找到该资源';
                    break;
                case 405:
                    error.message = '请求方法未允许';
                    break;
                case 408:
                    error.message = '请求超时';
                    break;
                case 500:
                    error.message = '服务器端出错';
                    break;
                case 501:
                    error.message = '网络未实现';
                    break;
                case 502:
                    error.message = '网络错误';
                    break;
                case 503:
                    error.message = '服务不可用';
                    break;
                case 504:
                    error.message = '网络超时';
                    break;
                case 505:
                    error.message = 'http版本不支持该请求';
                    break;
                default:
                    error.message = `连接错误${error.response.status}`;
            }

            Toast(error.message); //提示信息

            return Promise.reject(error.response);
        }

        return Promise.reject(error);
    }
);

/**
 * post、put、patch共用请求
 * @param {String} type 请求类型
 * @param {String} url 请求的url地址
 * @param {Object} params 请求提交的参数
 */
function commonRequest(url, params, type, config) {
    return new Promise((resolve, reject) => {
        axios[type](url, qs.stringify(params), config).then(
            //qs序列化参数
            res => {
                resolve(res.data);
            },
            err => {
                reject(err.data);
            }
        );
    });
}

export default {
    /**
     * get请求
     * @param {String} url 请求的url地址
     * @param {Object} params 请求提交的参数
     */
    get(url, params, config) {
        return new Promise((resolve, reject) => {
            config = config || {};
            config.params = params;
            axios.get(url, config).then(
                res => {
                    resolve(res.data);
                },
                err => {
                    reject(err);
                }
            );
        });
    },
    /**
     * post请求
     * @param {String} url 请求的url地址
     * @param {Object} params 请求提交的参数
     */
    post(url, params, config) {
        return commonRequest(url, params, 'post', config);
    },
    /**
     * put请求
     * @param {String} url 请求的url地址
     * @param {Object} params 请求提交的参数
     */
    put(url, params, config) {
        return commonRequest(url, params, 'put', config);
    },
    /**
     * delete请求
     * @param {String} url 请求的url地址
     * @param {Object} params 请求提交的参数
     */
    delete(url, params, config) {
        return new Promise((resolve, reject) => {
            config = config || {};
            config.params = params;
            axios.delete(url, config).then(
                res => {
                    resolve(res.data);
                },
                err => {
                    reject(err.data);
                }
            );
        });
    },
    /**
     * patch请求
     * @param {String} url 请求的url地址
     * @param {Object} params 请求提交的参数
     */
    patch(url, params, config) {
        return commonRequest(url, params, 'patch', config);
    }
};